<template>
  <div
    class="dropdown multi-select-dropdown"
    ref="dropdown"
  >
    <button
      class="btn dropdown-toggle dropdown-button btn-outline-secondary"
      type="button"
      @click="toggleDropdown"
      :aria-expanded="isOpen"
      :style="{ width: buttonWidth }"
    >
      {{ selectedLabels }}
    </button>
    <div
      v-if="isOpen"
      class="dropdown-menu show dropdown-menu-scrollable"
    >
      <input
        type="text"
        v-model="searchQuery"
        class="form-control dropdown-search"
        :style="{ width: buttonWidth }"
        placeholder="Поиск..."
      />
      <div
        v-for="option in filteredOptions"
        :key="option.value"
        class="dropdown-item"
      >
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            :id="option.value"
            :value="option.value"
            v-model="selectedValues"
          />
          <label
            class="form-check-label"
            :for="option.value"
            >{{ option.label }}</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    required: true,
    default: () => [],
  },
  modelValue: {
    type: Array,
    required: true,
    default: () => [],
  },
  buttonWidth: {
    type: String,
    required: false,
    default: '100%',
  },
})

const emit = defineEmits(['update:modelValue', 'changeTdStyle'])

const isOpen = ref(false)
const searchQuery = ref('')
const selectedValues = ref([...props.modelValue])

const dropdown = ref(null)

const selectedLabels = computed(() => {
  if (selectedValues.value.length === 0) {
    return 'Выберите опции'
  }
  return props.options
    .filter(option => selectedValues.value.includes(option.value))
    .map(option => option.label)
    .join('[..]')
})

const filteredOptions = computed(() => {
  if (!searchQuery.value) {
    return props.options
  }
  const query = searchQuery.value.toLowerCase()
  return props.options.filter(option => option.label.toLowerCase().includes(query))
})

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
  if (!isOpen.value) {
    searchQuery.value = '' // Сброс строки поиска при закрытии
  }
  emit('changeTdStyle', isOpen.value)
}

const handleClickOutside = event => {
  if (dropdown.value && !dropdown.value.contains(event.target)) {
    isOpen.value = false
    emit('changeTdStyle', isOpen.value)
  }
}

watch(selectedValues, newValues => {
  emit('update:modelValue', newValues)
})

watch(
  () => props.modelValue,
  newValues => {
    selectedValues.value = newValues
  }
)

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
